import type React from "react";
import { ReactComponent as Svg } from "./assets/time-0900-circle.svg";
import * as styles from "./Icon.module.scss";

type Clock2Props = React.SVGProps<SVGSVGElement>;

export const Clock2 = ({ className, ...props }: Clock2Props) => (
  <Svg className={className ?? styles.base} {...props} />
);
